import React , {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
class ProductLoader extends Component{
    render(){
        return(
            <div>
                <div className="row">
                    <div className="col">
                        <Skeleton count={1} height={176}/>
                    </div>
                </div>
            </div>

        )
    }
}


export default ProductLoader;